"use client"

import React from 'react'
import { useTranslations } from 'next-intl'

export default function CoreSkills() {
  const t = useTranslations('coreSkills')

  // next-intl may return strings at runtime (not arrays). To be defensive,
  // accept either an array or a delimiter-joined string ("||") and
  // normalize to string[] for rendering.
  const parseTranslatedItems = (value: unknown): string[] => {
    if (Array.isArray(value)) {
      return value.filter(Boolean).map(String)
    }
    if (typeof value === 'string') {
      return value.split('||').map((s) => s.trim()).filter(Boolean)
    }
    return []
  }

  const groups = [
    {
      key: 'fullStack',
      title: t('fullStack.title'),
      items: parseTranslatedItems(t('fullStack.items'))
    },
    {
      key: 'database',
      title: t('database.title'),
      items: parseTranslatedItems(t('database.items'))
    },
    {
      key: 'visualization',
      title: t('visualization.title'),
      items: parseTranslatedItems(t('visualization.items'))
    },
    {
      key: 'writing',
      title: t('writing.title'),
      items: parseTranslatedItems(t('writing.items'))
    }
  ]

  return (
    <section id="core-skills" className="py-16 px-6">
      <div className="container mx-auto max-w-6xl text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-bold mb-2">{t('title')}</h2>
        {t('description') && <p className="text-lg text-medium-contrast max-w-2xl mx-auto">{t('description')}</p>}
      </div>

      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {groups.map((g) => (
            <div key={g.key} className="text-left">
              <h4 className="text-xl font-semibold mb-3 flex items-center gap-3">
                <span className="w-3 h-3 inline-block bg-sky-500 rounded-sm" aria-hidden />
                {g.title}
              </h4>
              <ul className="list-disc ml-6 space-y-2 text-medium-contrast">
                {g.items && (g.items as string[]).map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
